/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import groupSelectors from 'redux/reduxStore/group';

import GroupLogoTemplate from './GroupLogo.template';

function mapStateToProps(state) {
  return {
    groupMetadata: groupSelectors.getActiveGroup(state),
  };
}

const GroupLogo = (props) => (
  <GroupLogoTemplate {...props} />
);

export default connect(mapStateToProps)(GroupLogo);